import {SendCodeResponsePayload} from '../../../models/api';

export default {
  message: 'Вам отправлено письмо со ссылкой на подтверждение новой эл. почты.', // 'SMS с кодом подтверждения отправлено на номер телефона +7 912 0** ** 27',
  validCountdown: 300,
  resendCountdown: 0,
  codeId: 0,
} as SendCodeResponsePayload;
